// @ts-nocheck
import React from 'react';

/**
 * Tabs — underline-style tabs with optional count badges. Controlled via
 * `value` + `onChange`. `items` is an array of `{ value, label, count? }`.
 *
 * Renders only the navigation; pages render their own panel content.
 */
const Tabs = ({ value, onChange, items = [], className = '' }) => (
  <div className={`mov-tabs-bar flex gap-0.5 mb-4 ${className}`}>
    {items.map((it) => {
      const active = it.value === value;
      return (
        <button
          key={it.value}
          type="button"
          onClick={() => onChange && onChange(it.value)}
          aria-pressed={active}
          className={`mov-tab ${active ? 'is-on' : ''}`}
        >
          {it.label}
          {typeof it.count === 'number' && <span className="mov-mono mov-tab-badge">{it.count}</span>}
        </button>
      );
    })}
  </div>
);

export default Tabs;
